import { Injectable } from '@angular/core';
import * as dk from 'assets/i18n/dk.json';
import * as en from 'assets/i18n/en.json';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class TranslateService {
  data: any = {};
  constructor(private http: HttpClient) {}

  use(lang: 'en' | 'dk'): void {
    this.data = lang === 'en' ? en : dk;
  }

  getTextsByLangAndPage(lang: string, page: string): Observable<any> {
    const url = `${environment.dashboardBaseRef}api/text/${lang}/${page}`;
    return this.http.get(url);
  }
}
